import { getImageUrl } from "@/lib/aws-amplify/host-storage";
import type { ContactMessageItem } from "@/lib/gql/__generated__/graphql";

import { ImageAndDialog } from "./image-and-dialog";

type Props = {
	message: ContactMessageItem["message"];
	images: ContactMessageItem["images"];
};

export const MessageAndImages = ({ message, images }: Props) => {
	const canShowImages = images && images.length > 0;

	return (
		<div className="flex flex-col gap-y-8">
			<p className="whitespace-pre-wrap text-sm leading-[1.6] tracking-wider">{message}</p>

			<div className="flex flex-col gap-y-8">
				{canShowImages && (
					<div className="grid grid-cols-2 gap-4 [&>*:not(:first-of-type)]:pt-4 [&>*]:cursor-pointer">
						{images?.map((image) => {
							const src = getImageUrl(image);

							return <ImageAndDialog key={src} imageSrc={src} />;
						})}
					</div>
				)}
			</div>
		</div>
	);
};

MessageAndImages.displayName = "MessageAndImages";
